import { Promise } from 'rsvp';
import { getOwner } from '@ember/application';

// Inspired by https://github.com/devotox/ember-cli-liquid-fire-events/blob/master/addon/transitions/after-animate.js
export default async function (this: any, targetTransitionName: any, ...args: any[]) {
  let viewRoot = this.oldView || this.newView;
  let service = getOwner(viewRoot)?.lookup('service:liquid-fire');

  return new Promise((resolve) => {
    if (service == null) {
      return;
    }

    service.trigger('transitionStart');
    resolve();
  })
    .then(() => {
      return this.lookup(targetTransitionName ?? 'default').apply(this, args);
    })
    .then((infos) => {
      if (service == null) {
        return;
      }

      service.trigger('transitionEnd', this.newView);
      return infos;
    });
}
